import type React from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import { MembershipBottomBanner } from '#src/app/shared/components/membership';

export const MembershipBottomBannerWrapper: React.FC<EmptyProps> = () => {
	const {
		data: { petition, membershipBottomBannerData },
	} = usePetitionDetailsPageData();

	// null when the banner is disabled or its configuration is incomplete
	if (!membershipBottomBannerData) return null;

	return (
		<MembershipBottomBanner
			slug={petition.slug}
			sourceLocation="petition_membership_popup"
			data={membershipBottomBannerData}
		/>
	);
};
